/**
 * Created by oksuztepe on 09/01/17.
 */


export enum ToolbarEventPageEnum{
  NONE,
  JOBS,
  JOB_DETAILS,
  JOB_SIGN_REQUEST,
  JOB_SELF_SIGNING,
  HOME,
  ACCOUNT,
  UPGRADE,
  SUBSCRIPTION,
  PAYMENT_RESULT,
  COMBINE,
  VIEW,
  VALIDATE,
  PREPARE,
  PREPARE_SELF,
  DESIGN,
  DOC_REQUEST,
  JOB_MULTISIGN_REQUEST,
  TEMPLATE_PREPARE,
  TEMPLATE_PREPARE_SELF
};


export class ToolbarEvent {

    attachmentCount?: number;

    /**
     * Whether a Signing Log can be downloaded for this job with the code in hand.
     *
     * Set from what the API says, never decided locally: /view/{code} serves both completion
     * codes (is_validation='N', 15-30 day window) and validation codes (is_validation='Y', up
     * to ten years), and the log carries every signer's email, IP and user agent, so only the
     * server can say whether this particular code may have it.
     */
    signingLogAvailable?: boolean;

    constructor(public page:ToolbarEventPageEnum, public jobType:string, public jobOwnerId:number, public recipientState:string, public title: string, public value: string, public location:string, public sharePublicLink:string, public isDownloadAllowed:string) {

  }
}
